import { render } from "./index.vue?vue&type=template&id=2a2a071c&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2a2a071c&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2a071c"]])

export default __exports__